export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_15_PowerProtect_end.4366d5c5.jpg";